// extracted by mini-css-extract-plugin
export default {"outgrown":"HomeBmiCheckPage_outgrown__tQ14c"};